/** Component for collection functions */
export function collection() {
  var _THIS = this;
  this.elemContainer = null;
  this.init = function (elemcontainer) {
    if (!$("body").hasClass("template-collection")) {
      return;
    }

    checkFilters(".multipleSelection");
    registerEvents();
    initFilters();
    cleanTitleTags();

    (async () => {
      const { initPromoFlags, initPromoNames, initComingSoonFlag } = await import(
        theme.components.commonURL
      );

      initPromoFlags(".product-card .product-item-promo-flag");
      initPromoNames(".product-card .product-item-promo-name");
      initComingSoonFlag(".product-card .product-item-coming-soon-flag")
    })();

    $(".collection-filter-control, #filters-back, .filtersCat").click(
      function () {
        $(".collection-filters-content").toggleClass("filtersShow");
        $(".collection-filters-content").toggleClass("desktop");
        $("body").toggleClass("showModel");
      }
    );
  };

  var registerEvents = function () {
    $(document).on("click", ".collection-filter-item", function (e) {
      if ($(this).is(":checked")) {
        e.preventDefault();
        if ($(this).val() !== "") {
          var idd = $(this).parents(".opened").attr("id");
          console.log(idd);
          var newurl = $(this).val();
          window.location.href = newurl;
        }
      }
    });

    $(document).on("change", ".sel-collection-sort", function (e) {
      if ($(this).val() !== "") {
        var newurl = setURLParameter(
          window.location.href,
          "sort_by",
          $(this).val()
        );
        window.location.href = newurl;
      }
    });

    $(document).on("click", ".collection-filters-apply", function (e) {
      e.preventDefault();
      $(".filter").toggleClass("hide");
      $(".collection-filter-control").toggleClass("active");
    });

    $(document).on(
      "keyup",
      ".collection-filter-search-name input.search-input",
      function (e) {
        e.preventDefault();
        searchFilter($(this), e);
      }
    );

    $(document).on("click", "a.collection-filter-title", function (e) {
      e.preventDefault();
      setSelectedFilterSection($(this), e);
    });

    $(document).on(
      "click",
      ".collection-filters-headings a.collection-filter-title",
      function (e) {
        e.preventDefault();
        $(".collection-filters-headings li").removeClass("mobile-show");
        $(this).parent().addClass("mobile-show");
        var targetedDiv = $(this).attr("data-filter-section");
        $("." + targetedDiv)
          .find("a.collection-filter-title")
          .trigger("click");
      }
    );
  };

  var initFilters = function () {
    //The first filter will be preselected
    $(".collection-filter-section").eq(0).addClass("mobile-show");
    $(".collection-filters-headings li").eq(0).addClass("mobile-show");
  };
  var cleanTitleTags = function () {
    try {
      var searchLocale =
        "__" + (Shopify.locale == "" ? "en" : Shopify.locale) + "__";

      $(".collection-filters .collection-filter-section").each(function () {
        var getCollectionHeading = $(this).find("h3").attr("data-heading-name");
        var getCollectionHeadingText = $(this)
          .find("h3")
          .attr("data-heading-original-name");

        $(this)
          .find(".collection-filter-item")
          .each(function () {
            var searchString = $(this).attr("data-tag-original");
            var currentTitle = $(this).find("a").attr("title");
            var newTitle = currentTitle.split("__").join(" ");

            if (searchString.indexOf(searchLocale) !== -1) {
              newTitle = currentTitle.split(searchLocale).join(" ");
            }

            newTitle = newTitle.replace(
              getCollectionHeading,
              getCollectionHeadingText
            );

            $(this).find("a").attr("title", newTitle);
          });
      });
    } catch (err) {}
  };

  var setSelectedFilterSection = function (element, e) {
    //console.log(element)
    $(".collection-filter-section").removeClass("mobile-show");
    element.closest(".collection-filter-section").addClass("mobile-show");
  };

  var updateFilterScroll = function (filtersection) {
    $(filtersection).each(function () {
      if ($(this).find(".collection-filter-item:not(.hide)").length > 6) {
        $(this).addClass("scroll");
      } else {
        $(this).removeClass("scroll");
      }
    });
  };

  var checkFilters = function (filtersection) {
    var isAnyFilterSelected = false;
    var selectedFilterHTML = "";
    $(filtersection).each(function () {
      if ($(this).find(".collection-filter-item:checked")) {
        isAnyFilterSelected = true;
        var getSelectedTag = encodeURIComponent(
          $(this).find(".collection-filter-item:checked").attr("data-tag-type")
        );
        if (getSelectedTag != "undefined") {
          $(this)
            .find(".collection-filter-item:checked")
            .parents(".multipleSelection")
            .find(".selectBox")
            .addClass("showCount");
          $(this).find(".collection-clear-filter").removeClass("hide");
          $(this)
            .find(".collection-clear-filter")
            .find("a")
            .attr(
              "href",
              $(this).find(".collection-filter-item:checked").val()
            );
          $(this)
            .find(".collection-filter-item")
            .each(function () {
              var getHref = $(this).attr("value");
              if (getHref != undefined) {
                var nhref = getHref;
                //console.log(getHref)
                //console.log(getSelectedTag+"+")
                if (getHref.indexOf(getSelectedTag + "+") !== -1) {
                  nhref = getHref.replace(getSelectedTag + "+", "");
                } else if (getHref.indexOf("+" + getSelectedTag) !== -1) {
                  nhref = getHref.replace("+" + getSelectedTag, "");
                } else if (getHref.indexOf(getSelectedTag) !== -1) {
                  nhref = getHref.replace(getSelectedTag, "");
                }
                $(this).attr("value", nhref);

                if ($(this).hasClass("selected")) {
                  //selectedFilterHTML +="<a href='3" +  $(this).find("a").attr("href")+ "'>"  + $(this).find("a").text() + "<span class='remove'></span></a>"
                }
              }
            });
        }
      }
    });
  };

  var searchFilter = function (element, e) {
    var searchText = element.val().toLowerCase();
    var searchItemsContainer = element.attr("data-search-element");
    var searchElements = $(searchItemsContainer).find(
      ".collection-filter-item"
    );

    var code = e.keyCode || e.which;
    if (code == 13) {
    } else {
      if (searchText !== "") {
        searchElements.addClass("hide");
        searchElements.each(function () {
          var getTagValue = $(this).attr("data-tag-value").toLowerCase();
          //console.log(getTagValue + "  " +  searchText)
          if (getTagValue.indexOf(searchText) !== -1) {
            $(this).removeClass("hide");
          }
        });
      } else {
        searchElements.removeClass("hide");
      }
    }

    updateFilterScroll(searchItemsContainer);
  };

  var setURLParameter = function (url, key, value) {
    var key = encodeURIComponent(key),
      value = encodeURIComponent(value);
    var urlQueryString = "";
    var baseUrl = url.split("?")[0],
      newParam = key + "=" + value,
      params = "?" + newParam;

    if (url.split("?")[1] == undefined) {
      // if there are no query strings, make urlQueryString empty
      urlQueryString = "";
    } else {
      urlQueryString = "?" + url.split("?")[1];
    }

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      var updateRegex = new RegExp("([?&])" + key + "[^&]*");
      var removeRegex = new RegExp("([?&])" + key + "=[^&;]+[&;]?");

      if (typeof value === "undefined" || value === null || value === "") {
        params = urlQueryString.replace(removeRegex, "$1");
        params = params.replace(/[&;]$/, "");
      } else if (urlQueryString.match(updateRegex) !== null) {
        // If param exists already, update it
        params = urlQueryString.replace(updateRegex, "$1" + newParam);
      } else if (urlQueryString == "") {
        params = "?" + newParam;
      } else {
        // Otherwise, add it to end of query string
        params = urlQueryString + "&" + newParam;
      }
    }

    // no parameter was set so we don't need the question mark
    params = params === "?" ? "" : params;

    return baseUrl + params;
  };
}
